"use client";

import { usePathname } from "next/navigation";
import PurposeAILanding from "~/components/purposeai-landing";
import IndustryLanding from "~/components/industry-landing";
import AboutUs from "~/components/about-us";
import PricingPage from "~/components/pricing-page";
import { industryConfigs } from "~/lib/industry-configs";

export default function PurposeAIDomainRouter() {
  const pathname = usePathname();
  
  // Check if we're on the about page
  if (pathname === "/about") {
    return <AboutUs />;
  }
  
  // Check if we're on the pricing page
  if (pathname === "/pricing") {
    return <PricingPage />;
  }
  
  // Check for industry subdomains (this would need to be passed from layout)
  // For now, just render the main landing page
  return <PurposeAILanding />;
}

